import withStyles from "@material-ui/core/styles/withStyles";
import axios from "axios";
import { detect } from "detect-browser";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  SubscriptionLogin,
  updateAuthentication,
} from "../../../Actions/AuthenticationAction";
import { instance } from "../../../Actions/AxiosInstance";
import { getFormattedPermissions } from "../../../Actions/commonAction";
import { updateSubscriptionInfo } from "../../../Actions/SubscriptionInfo";
import { FEATUREKEYS } from "../../../Constants";
import Configs from "../../../Constants/Configs";
import { getOSName } from "../../../Handlers/getters";
import { backToHome } from "../../../Handlers/setters";

const browser = detect();

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class LogInAsSSO extends React.Component {
  constructor(props) {
    super(props);
    this.state = { CommonError: "" };
    this.validateStart = this.validateStart.bind(this);
    this.getValidate = this.getValidate.bind(this);
  }

  componentDidMount() {
    console.log(
      "this.props.match.params.token: ",
      this.props.match.params.token,
    );
    if (this.props.match.params.token == "org_not_found") {
      backToHome();
    } else if (this.props.match.params.token == "user_error") {
      backToHome();
    } else if (this.props.match.params.token == "session-expired") {
      backToHome();
    } else {
      this.getValidate();
    }
  }

  async getValidate() {
    const token = `Bearer ${this.props.match.params.token}`;
    const ConvertHeadersForBackend = (headers) => {
      headers.Authorization = token;
      headers["Content-Type"] = "application/json";
      return headers;
    };

    const tempinstance = axios.create({
      baseURL: Configs.API_URL,
      transformRequest: [
        // eslint-disable-next-line no-unused-vars
        (data, headers) => {
          headers = ConvertHeadersForBackend(headers);
          return JSON.stringify(data);
        },
      ],
    });

    const data = {
      systemdetail: getOSName(),
      browserdetail: browser.name,
      logintype: 1,
      devicetokenid: "",
    };

    try {
      const loginresult = await tempinstance.post(
        "subscription/loginbytoken",
        data,
      );
      const plans = await instance.post(`superuser/getcompanyplanconfig`, {
        accountid:
          loginresult.data.result[0] && loginresult.data.result[0].accountid,
        subscriptionid:
          loginresult.data.result[0] &&
          loginresult.data.result[0].subscriptionid,
      });
      const objsuportplan = plans.data.result[0]
        ? plans.data.result.find((x) => x.typeid == 1)
        : null;
      const objpriceplan = plans.data.result[0]
        ? plans.data.result.find((x) => x.typeid == 2)
        : null;
      this.props.updateSubscriptionInfo(
        "SUBSCRIPTIONINFO_UPDATED_WITH_FULLFILLED",
        loginresult.data.result[0],
      );
      this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
        IsFulfilled: true,
        data: {
          ...loginresult.data.result[0],
          objsuportplan,
          objpriceplan,
        },
      });

      const features = await instance.get("subscription/getuserpermssion");

      const login = { ...loginresult.data.result[0] };
      login.features = getFormattedPermissions(features.data.result);
      const migrationlist = await instance.get(
        "superuser/getconfigmigrationinit",
      );
      login.migration = migrationlist.data.result;
      this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
        IsFulfilled: true,
        data: login,
      });

      setTimeout(() => {
        this.validateStart({ loginres: login });
      }, 200);
    } catch (e) {
      // const result = window.confirm("Login fail, please try again.");
      // if (result == true) {
      window.open("/login/user_error", "_self");

      // }
      // this.props.enqueueSnackbar(get(e, "response.data.error.message", "Something went wrong"), { variant: "error" });
    }
  }

  async validateStart({ loginres }) {
    const isAdmin = loginres.masterprofileid >= 9;
    let hasAttendanceAppAccess = isAdmin;
    let hasLeaveAppAccess = isAdmin;
    let hasExpenseAppAccess = isAdmin;
    let hasPerformAppAccess = isAdmin;
    let hasCompensatorAccess = isAdmin;
    const hasDriveAccess = isAdmin;
    const hasLetterAccess = isAdmin;
    if (!isAdmin) {
      try {
        let data = {
          featurekey: "attendanceLogs",
          workflowfortypeid: 2,
        };
        const attendanceapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasAttendanceAppAccess = isAdmin || get(attendanceapproverreportee, "data.result[0]", "");
        hasAttendanceAppAccess = get(
          attendanceapproverreportee,
          "data.result[0]",
          "",
        );
        data = {
          featurekey: "leaveBalanceAndHistory",
          workflowfortypeid: 3,
        };
        const leaveapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasLeaveAppAccess = isAdmin || get(leaveapproverreportee, "data.result[0]", "");
        hasLeaveAppAccess = get(leaveapproverreportee, "data.result[0]", "");
        data = {
          featurekey: "employeeExpense",
          workflowfortypeid: 5,
        };
        const expenseapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasExpenseAppAccess = isAdmin || get(expenseapproverreportee, "data.result[0]", "");

        hasExpenseAppAccess = get(
          expenseapproverreportee,
          "data.result[0]",
          "",
        );

        const checkiscompensator = await instance.get(
          `expense/checkiscompensator`,
        );
        // hasCompensatorAccess = isAdmin || get(checkiscompensator, "data.result[0].iscompensator", "");
        hasCompensatorAccess = get(
          checkiscompensator,
          "data.result[0].iscompensator",
          "",
        );
        data = {
          featurekey: "degree",
          workflowfortypeid: 6,
        };
        const performapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasPerformAppAccess = isAdmin || get(performapproverreportee, "data.result[0]", "");
        hasPerformAppAccess = get(
          performapproverreportee,
          "data.result[0]",
          "",
        );
      } catch (err) {}
    }

    if (hasCompensatorAccess) {
      get(loginres, "features", []).push({
        hasAppAccess: true,
        permissions: {
          readOnly: false,
          editable: true,
        },
        featureid: 314,
      });
    }

    loginres = {
      ...loginres,
      features: get(loginres, "features", []).map((feature) => {
        const res = feature;
        if (feature.featureid == FEATUREKEYS.attendance) {
          res.hasAppAccess = hasAttendanceAppAccess;
        } else if (feature.featureid == FEATUREKEYS.leave) {
          res.hasAppAccess = hasLeaveAppAccess;
        } else if (feature.featureid == FEATUREKEYS.employeeExpense) {
          res.hasAppAccess = hasExpenseAppAccess;
        } else if (feature.featureid == FEATUREKEYS.companyDrive) {
          res.hasAppAccess = hasDriveAccess;
        } else if (feature.featureid == FEATUREKEYS.letters) {
          res.hasAppAccess = hasLetterAccess;
        } else if (feature.featureid == FEATUREKEYS.degree) {
          res.hasAppAccess = hasPerformAppAccess;
        }
        return res;
      }),
    };
    this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
      IsFulfilled: true,
      data: loginres,
    });
    window.localStorage.setItem(
      "loggedin",
      get(loginres, "data.result[0].userid", ""),
    );
    setTimeout(() => {
      const prev = window.localStorage.getItem("prevLink");
      const URL = `${window.location.origin}`;
      prev ? window.open(URL + prev, "_self") : backToHome();
    }, 200);
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSubscriptionInfo,
      updateAuthentication: (type, payload) =>
        updateAuthentication(type, payload),
      SubscriptionLogin: (data) => SubscriptionLogin(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withStyles(styles)(withSnackbar(LogInAsSSO))));
// export default withStyles(styles)(withSnackbar(LogInAsAdmin));
